enum Typographies {
  FONT_FAMILY_MAIN = "'Inter', sans-serif",
  // Sizes
  FONT_SIZE_CAPTION = 10,
  FONT_SIZE_CAPTION_2 = 12,
  FONT_SIZE_BODY = 16,
  FONT_SIZE_H1 = 24,
  FONT_SIZE_H2 = 20,
  FONT_SIZE_H3 = 18,
  FONT_SIZE_H4 = 16,
  // Weights
  FONT_WEIGHT_CAPTION = 400,
  FONT_WEIGHT_BODY = 400,
  FONT_WEIGHT_H1 = 600,
  FONT_WEIGHT_H2 = 700,
  FONT_WEIGHT_H3 = 600,
  FONT_WEIGHT_H4 = 600,
}

export default Typographies;
